import PropTypes from 'prop-types';
import * as React from 'react';
import SpinnerIcon from 'common/components/SpinnerIcon';

class Spinner extends React.Component {
  static propTypes = {
    text: PropTypes.string
  };

  render() {
    return (
      <div className="m-loader">
        <div className="m-loader-container">
          <div className="m-loader-spinner">
            <SpinnerIcon />
          </div>
          {this.props.text && <p>{this.props.text}</p>}
        </div>
      </div>
    );
  }
}

export default Spinner;
